import { render, staticRenderFns } from "./SearchResponsesHeaderActions.vue?vue&type=template&id=b2ddb472&scoped=true"
import script from "./SearchResponsesHeaderActions.vue?vue&type=script&lang=js"
export * from "./SearchResponsesHeaderActions.vue?vue&type=script&lang=js"
import style0 from "./SearchResponsesHeaderActions.vue?vue&type=style&index=0&id=b2ddb472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ddb472",
  null
  
)

export default component.exports